
export const featurePaths = {
    TrackShipments: "/trackshipments",
    MakePayment: "/makepayment",
    SignUp: "/signup",
    TrackandTracePod: "/TrackandTracePod",
    PrivacyPolicy: "/privacypolicy",
    Terms: "/terms",
    QuoteTermsConditions: "/quotetermsconditions",
    CookiePolicy: "/cookiepolicy",

} as const;

export const apiPaths = {} as const;
